var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',{staticClass:"table-card md-layout"},[_c('md-card-header',{staticClass:"md-card-header-icon md-card-header-green md-layout md-alignment-center"},[(_vm.title)?_c('h4',{staticClass:"md-layout-item md-size-75"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"md-size-25 ml-auto"},[_vm._t("header")],2)]),_vm._v(" "),_c('md-card-content',[_vm._t("content")],2),_vm._v(" "),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/Tables/TableCardLayout.vue